import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class TPRDataService {
  apiEP: string = window.apiUrl;

  constructor(private http: HttpClient) {}

  getTprCompanyBrokerDetails(ticker: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/tpr_page/get_single_company_broker_detail?ticker=${ticker}`,
    );
  }

  saveTprGridDetails(tabDimension, gridColumns): Observable<any> {
    const reqObj = {
      dimension_name: tabDimension,
      jsonData: {
        grid_columns: gridColumns,
      },
    };
    return this.http.post(
      `${this.apiEP}/tpr_page/save_tpr_grid_columns`,
      reqObj,
    );
  }

  getTprDocumentGridDetails(params): Observable<any> {
    const url = `${this.apiEP}/tpr_page/get_tpr_documents`;
    return this.http.post(url, params);
  }

  getVsPeersMeta(ticker): Observable<any> {
    const url = `${this.apiEP}/tpr_page/get_tpr_meta?ticker=${ticker}&tab=peer`;
    return this.http.get(url);
  }

  getVsPeersData(params) {
    const url = `${this.apiEP}/tpr_page/get_tpr_multi_company_data?${params}`;
    return this.http.get(url);
  }

  saveTprVsPeersDetails(userTprSettingDetails: any): Observable<any> {
    const jsonData = {
      peer_ticker: userTprSettingDetails.tickers,
      orientation: userTprSettingDetails.orientation,
      currency: userTprSettingDetails.currency,
      price_performance: userTprSettingDetails.pricePerformance,
    };
    const reqObj = {
      company: userTprSettingDetails.currentTicker,
      jsonData: {
        valuationpeertab: jsonData,
      },
      cut: null,
      is_tpr_page: true,
    };

    return this.http.post(
      `${this.apiEP}/valuation_page/save_company_valuation_settings`,
      reqObj,
    );
  }

  exportTprCompany(params): Observable<any> {
    return this.http.get(`${this.apiEP}/addin/export?${params}`);
  }

  saveGridpanelshistory(postObj): Observable<any> {
    return this.http.post(`${this.apiEP}/api/gridpanelshistory/`, postObj);
  }
}
